const RESIZE_HANDLER_KEY = '__waajoAutogrowResize'

function attachResize(el) {
  el.style.overflow = 'auto'
  el.style.resize = 'none'

  const resize = () => {
    el.style.height = 'auto'
    const maxHeight = parseInt(getComputedStyle(el).maxHeight) || Infinity
    el.style.height = Math.min(el.scrollHeight, maxHeight) + 'px'
  }

  el[RESIZE_HANDLER_KEY] = resize
  el.addEventListener('input', resize)
  resize()
}

export default {
  inserted(el) {
    attachResize(el)
  },
  componentUpdated(el) {
    // Textarea bisa di-reset oleh Vue (mis. setelah kirim pesan); hitung ulang
    // tinggi agar tidak menyisakan ruang kosong atau terpotong.
    const resize = el[RESIZE_HANDLER_KEY]
    if (resize) {
      resize()
    }
  },
  unbind(el) {
    const resize = el[RESIZE_HANDLER_KEY]
    if (resize) {
      el.removeEventListener('input', resize)
      delete el[RESIZE_HANDLER_KEY]
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/omni/autogrow.js